import React, { useEffect, useState, useRef, useCallback } from 'react';
import CommitmentsActivity from '../../../components/WeeklyPlan/Commintments';
import CustomPaginator from '../../../components/CustomPaginator';
import { tableMetadata } from './table.layout';
import { useQuery } from 'react-query';
import styles from './Commitments.module.scss';
import 'moment/locale/es';
import moment from 'moment';
import { getFlattenActivities, recursiveTasksFilterWp } from '../../../utils';
import { useSelector } from 'react-redux';
import {
  activityService,
  userService,
  taskService,
  calendarService
} from '../../../services';
import { WeeklyPlanCommitmentToolbar } from '../../../components/WeeklyPlan/Commintments/components/WeeklyplanCommitmentToolbar/WeeklyplanToolbar';
import CncForm from '../../../components/WeeklyPlan/Cnc/CncForm';
import {
  filterDeletedCommitmentTasks,
  findCurrentWeekCommitment,
  getListCncs,
  getWeekCommitments
} from '../weeklyPlan.helper';
import { getCncList, getTasksWithRoute } from '../cncs/cncs.helper';
import Manpower from '../../../components/WeeklyPlan/Commintments/components/ManpowerInfo/ManpowerInfo';
import useSubtradeUser from '../../../hooks/useSubtradeUser';
import { DeletedTaskIcon } from '../../../icons';
import ModalSystem from '../../../components/DesignSystem/ModalSystem';
import { ModalContentTasksCommitmentDeleted } from './ModalContentTasksCommitmentDeleted/ModalContentTasksCommitmentDeleted';
import { useGetDefaultWeeklyPlan } from './hooks/useGetDefaultWeeklyPlan';
import { useGetWeeklyPlanByNumber } from './hooks/useGetWeeklyPlanByNumber';
import { PlanHeader } from '../../../components/WeeklyPlan/Commintments/components/PlanHeader/PlanHeader';
import { EmptyWWPData } from '../../../components/WeeklyPlan/Commintments/components/EmptyWWPData/EmptyWWPData';
import { EmptyWWPError } from '../../../components/WeeklyPlan/Commintments/components/EmptyWWPError/EmptyWWPError';
import { trackingEvent } from '../../../analytics';
import { AMPLITUDE_SERVICE } from '../../../analytics/constants';
import { getBasicAmplitudEventProperties } from '../../../analytics/utils';
import { useHistory } from 'react-router-dom';

const Commitments = ({ permission, t }) => {
  const customPaginator = useRef({});
  const [currentPage, setCurrentPage] = useState(0);
  const [tableConfig, setTableConfig] = useState([]);
  const [days, setDays] = useState([]);
  const [visibleFormCnc, setVisibleFormCnc] = useState({
    value: false,
    tasks: []
  });
  const [isLoadingTasks, setIsLookaheadLoading] = useState(true);
  const [isProgressColumns, setIsProgressColumns] = useState({
    progress: true,
    productivity: false
  });
  const [currentCommitment, setCurrentCommitment] = useState(null);
  const [currentYear, setCurrentYear] = useState(0);
  const [currentWeek, setCurrentWeek] = useState(0);
  const [allWeekCommitments, setAllWeekCommitments] = useState([]);
  const [allTaskCommitments, setAllTaskCommitments] = useState([]);
  const [deletedTaskCommitments, setDeletedTaskCommitments] = useState([]);
  const [tasksAddedCnc, setTasksAddedCnc] = useState([]);
  const subtradeRole = useSubtradeUser();
  const [dateRange, setDateRange] = useState({ start: '', end: '' });
  const [selectorData, setSelectorData] = useState({
    currentWWP: 0,
    lastWWP: 0,
    isWWPAvailable: false,
    isWWPValid: false
  });
  const [isFetchError, setIsFetchError] = useState(false);
  const [defaultWWPNumber, setDefaultWWPNumber] = useState(0);
  const [isDefaultWWPAvailable, setIsDefaultWWPAvailable] = useState(false);
  const [defaultWWPWeek, setDefaultWWPWeek] = useState(0);
  const [selectedWWPNumber, setSelectedWWPNumber] = useState(null);
  const [toSelectResponsables, setToSelectResponsables] = useState([]);
  const [showModalDeletedTasks, setShowModalDeletedTasks] = useState(false);
  const [activities, setActivities] = useState([]);
  const [lastLevelActivities, setLastLevelActivities] = useState({});
  const [calendars, setCalendars] = useState([]);
  const stateProject = useSelector((state) => state.projectState);
  const stateCompany = useSelector((state) => state.companyState);
  const history = useHistory();
  const avoidSendingEventOnRerenderRef = useRef(false);

  const {
    data: wwpDefaultData,
    isLoading: isLoadingDefault,
    isError: isErrorDefault
  } = useGetDefaultWeeklyPlan({
    projectId: stateProject.projectSelected,
    scheduleId: stateProject.sectorSelected
  });

  const {
    data: wwpByNumberData,
    isLoading: isLoadingByNumber,
    isError: isErrorByNumber
  } = useGetWeeklyPlanByNumber({
    projectId: stateProject.projectSelected,
    scheduleId: stateProject.sectorSelected,
    wwpNumber: selectedWWPNumber,
    defaultWWPNumber,
    isDefaultWWPAvailable
  });

  const isLoadingPlan = isLoadingDefault || isLoadingByNumber || isLoadingTasks;
  const hasLoadingError = isErrorDefault || isErrorByNumber || isFetchError;

  useEffect(() => {
    setIsLookaheadLoading(true);
    setSelectedWWPNumber(null);
    setIsDefaultWWPAvailable(false);
    setCurrentCommitment(null);
    setCurrentWeek(0);
    setCurrentYear(0);
    setDateRange({ start: '', end: '' });
    setActivities([]);
    setDays([]);
    setTableConfig([]);
    setLastLevelActivities({});
    setAllWeekCommitments([]);
    setAllTaskCommitments([]);
    setDeletedTaskCommitments([]);
    setSelectorData({
      currentWWP: 0,
      lastWWP: 0,
      isWWPAvailable: false,
      isWWPValid: false
    });
    setTasksAddedCnc([]);
  }, [stateProject.sectorSelected]);

  useEffect(() => {
    if (isLoadingPlan) {
      window.loader.show();
    } else {
      window.loader.hide();
    }
  }, [isLoadingPlan]);

  const cncListRq = useQuery(['cncListRq', stateProject.sectorSelected], () =>
    getListCncs(stateProject.sectorSelected)
  );
  const weekCommitmentsListRq = useQuery(
    ['weekCommitmentsListRq', stateProject.sectorSelected],
    () => getWeekCommitments(stateProject.sectorSelected)
  );

  useEffect(() => {
    if (wwpDefaultData && stateProject.sectorSelected) {
      const { commitmentData, planData } = wwpDefaultData;
      setSelectorData({
        currentWWP: planData.currentWWP,
        lastWWP: planData.totalPrevWWPs + planData.totalNextWWPs + 1,
        isWWPAvailable: planData.isWWPAvailable,
        isWWPValid: planData.isWWPValid
      });
      setDefaultWWPNumber(planData.currentWWP);
      setIsDefaultWWPAvailable(planData.isWWPAvailable);
      setDefaultWWPWeek(commitmentData.week);
      if (!planData.isWWPValid || Object.keys(commitmentData).length === 0) {
        setIsLookaheadLoading(false);
        return;
      }
      setCurrentCommitment(commitmentData);
      setCurrentWeek(commitmentData.week);
      setCurrentYear(commitmentData.year);
      setDateRange({
        start: commitmentData.start_date,
        end: commitmentData.end_date
      });
      getLookahead({
        scheduleId: stateProject.sectorSelected,
        commitmentId: commitmentData.id
      });
    }
  }, [wwpDefaultData, stateProject.sectorSelected]);

  useEffect(() => {
    if (wwpByNumberData) {
      const { commitmentData, planData } = wwpByNumberData;
      setSelectorData((prev) => ({
        ...prev,
        currentWWP: selectedWWPNumber,
        isWWPAvailable: true,
        isWWPValid: planData.isWWPValid
      }));
      setCurrentCommitment(commitmentData);
      setCurrentWeek(commitmentData.week);
      setCurrentYear(commitmentData.year);
      setDateRange({
        start: commitmentData.start_date,
        end: commitmentData.end_date
      });
      getLookahead({
        scheduleId: stateProject.sectorSelected,
        commitmentId: commitmentData.id
      });
    }
  }, [wwpByNumberData, selectedWWPNumber]);

  useEffect(() => {
    if (
      hasLoadingError ||
      (selectedWWPNumber === defaultWWPNumber && !isDefaultWWPAvailable)
    ) {
      setActivities([]);
      setLastLevelActivities({});
      setCurrentCommitment(null);
      setCurrentWeek(0);
      setCurrentYear(0);
      setDateRange({ start: '', end: '' });
      setSelectorData((prev) => ({
        ...prev,
        currentWWP: selectedWWPNumber,
        isWWPAvailable: false,
        isWWPValid: false
      }));
      setIsLookaheadLoading(false);
    }
  }, [hasLoadingError, selectedWWPNumber, isDefaultWWPAvailable]);

  const handleNavigateSelector = (direction) => {
    const newWWPNumber = selectorData.currentWWP + direction;
    if (newWWPNumber < 1 || newWWPNumber > selectorData.lastWWP) {
      return;
    }
    trackingEvent(
      'weekly_plan_navigation',
      {
        ...getBasicAmplitudEventProperties(),
        wwp_number: newWWPNumber,
        direction: direction === 1 ? 'forward' : 'backward'
      },
      AMPLITUDE_SERVICE
    );
    avoidSendingEventOnRerenderRef.current = false;
    setIsLookaheadLoading(true);
    setIsFetchError(false);
    setSelectedWWPNumber(newWWPNumber);
  };

  useEffect(() => {
    if (cncListRq.isSuccess && cncListRq.data.cncs) {
      getListsTasks();
    }
  }, [cncListRq.isSuccess]);

  const getListsTasks = () => {
    const listTmp = getCncList(cncListRq);
    if (listTmp.cncTasksArr) {
      setTasksAddedCnc(listTmp.cncTasksArr);
    }
  };

  useEffect(() => {
    if (!currentCommitment?.closed) {
      return;
    }
    setAllWeekCommitments((prevCommitments) => {
      if (!prevCommitments.length) {
        return prevCommitments;
      }
      const currentIdx = prevCommitments.findIndex(
        (commitment) => commitment.id === currentCommitment.id
      );
      if (currentIdx === -1 || prevCommitments[currentIdx]?.closed) {
        return prevCommitments;
      }
      const newCommitments = [...prevCommitments];
      newCommitments[currentIdx] = {
        ...newCommitments[currentIdx],
        closed: currentCommitment.closed
      };
      return newCommitments;
    });
  }, [currentCommitment?.closed]);

  useEffect(() => {
    if (currentWeek && weekCommitmentsListRq.isSuccess) {
      const currentWeekSelected = findCurrentWeekCommitment(
        weekCommitmentsListRq?.data?.weekcommitments,
        currentWeek,
        currentYear
      );
      if (currentWeekSelected) {
        const currentTasksDeleted = filterDeletedCommitmentTasks(
          currentWeekSelected.taskcommitments
        );
        setDeletedTaskCommitments(currentTasksDeleted);
      } else {
        setDeletedTaskCommitments([]);
      }
    }
  }, [
    currentWeek,
    currentYear,
    weekCommitmentsListRq.data,
    weekCommitmentsListRq.isSuccess
  ]);

  useEffect(() => {
    if (
      weekCommitmentsListRq.isSuccess &&
      weekCommitmentsListRq.data.weekcommitments
    ) {
      const weekData = weekCommitmentsListRq.data.weekcommitments;
      allTaskCommitmentsFn(weekData);
    }
  }, [weekCommitmentsListRq.data]);

  useEffect(() => {
    if (dateRange.start !== '') {
      const tableColumns = tableMetadata.filter((column) => {
        if (!column.showColumCommitment) return false;
        if (isProgressColumns.progress)
          return column.isProgress === isProgressColumns.progress;

        return column.isProductivity === isProgressColumns.productivity;
      });

      setDays([
        getDayTextFormart(0),
        getDayTextFormart(1),
        getDayTextFormart(2),
        getDayTextFormart(3),
        getDayTextFormart(4),
        getDayTextFormart(5),
        getDayTextFormart(6)
      ]);
      setTableConfig(tableColumns);
    }
  }, [dateRange.start, isProgressColumns]);

  const getDayTextFormart = (correlative) => {
    const date = moment.utc(dateRange.start).add('days', correlative);
    return date.format('ddd DD');
  };

  async function getLookahead({ scheduleId, commitmentId }) {
    try {
      const calendars = await calendarService.showBySector(scheduleId);
      setCalendars(calendars.calendar);
      setCurrentPage(0);
      const activities = await activityService.getLookaheadWeeklyPlanCommitment(
        {
          scheduleId,
          commitmentId
        }
      );
      const responsables = await userService.getBySector(scheduleId);
      setLastLevelActivities(activities);
      setToSelectResponsables(responsables.users);
      return refreshView(activities, false);
    } catch {
      setIsFetchError(true);
    } finally {
      setIsLookaheadLoading(false);
    }
  }

  const refreshView = (lastLevelActivitiesRefresh = lastLevelActivities) => {
    const lastLevelActivitiesFiltered = lastLevelActivitiesRefresh.activities;
    const filterWeek = ['Committed'];
    const data = recursiveTasksFilterWp(
      lastLevelActivitiesFiltered,
      filterWeek,
      dateRange
    );
    const dataFilterActivitiesShow = recursiveActivityFilter(data);
    const cloneActivities = dataFilterActivitiesShow.filter(
      (el) => el.tasks.length
    );
    if (currentCommitment) {
      cloneActivities.map((act) => {
        act.recalcCommitment = true;
        return act;
      });
    }
    if (lastLevelActivities) {
      setActivities(
        cloneActivities.sort(
          (a, b) => parseInt(a.correlative_id) - parseInt(b.correlative_id)
        )
      );
    }
    return cloneActivities;
  };

  const recursiveActivityFilter = (array) =>
    array.map((el) => {
      const tmpArr = [];
      tmpArr.push(el);
      const getFlatten = getFlattenActivities(tmpArr);
      const haveWp = getFlatten.some((el) => el.showWeeklyPlan);
      el.showWeeklyPlan = haveWp;
      return el;
    });

  const allTaskCommitmentsFn = async (weeks) => {
    setAllWeekCommitments(weeks);
    const allTasks = [];
    weeks.map((el) => {
      if (el.taskcommitments.length) {
        el.taskcommitments.map((tc) => {
          allTasks.push(tc);
        });
      }
    });
    const tasks = await getTasksWithRoute(
      allTasks,
      stateProject.sectorSelected,
      taskService
    );
    setAllTaskCommitments(tasks?.tasks || []);
  };

  const handleAddCnc = (task) => {
    setVisibleFormCnc({ value: true, tasks: [task] });
    trackingEvent(
      'RFV_screen_opened_from_WWP',
      {
        ...getBasicAmplitudEventProperties(),
        type: '+RFV'
      },
      AMPLITUDE_SERVICE
    );
  };

  const goToLookahead = () => {
    const { sectorSelected: scheduleId, projectSelected: projectId } =
      stateProject;
    const { currentCompany: organization } = stateCompany;
    history.push(
      `/${organization.id}/project/${projectId}/schedule/${scheduleId}/lookahead`
    );
  };
  const trackEmptyStateOnce = (type) => {
    if (!avoidSendingEventOnRerenderRef.current) {
      trackingEvent(
        'weekly_plan_empty_state_shown',
        {
          ...getBasicAmplitudEventProperties(),
          type
        },
        AMPLITUDE_SERVICE
      );
      avoidSendingEventOnRerenderRef.current = true;
    }
  };

  const getEmptyState = () => {
    const { currentWWP, lastWWP, isWWPAvailable, isWWPValid } = selectorData;
    const noWWPExists = currentWWP === 1 && lastWWP === 1 && !isWWPAvailable;
    const wwpIsInvalid = isWWPAvailable && !isWWPValid;
    const isCurrentWWP = currentWWP === defaultWWPNumber;
    const noWWPAvailable = !isWWPAvailable && !hasLoadingError;
    const noActivityData = lastLevelActivities?.activities?.length === 0;

    const create = (type, Component, props = {}) => {
      trackEmptyStateOnce(type);
      return <Component type={type} {...props} />;
    };
    const buttonProp = { buttonFn: goToLookahead };

    const cases = [
      {
        condition: wwpIsInvalid,
        render: () => create('INVALID_WWP_RANGE', EmptyWWPError)
      },
      {
        condition: noWWPExists,
        render: () => create('NO_WWP_EXISTS', EmptyWWPData, buttonProp)
      },
      {
        condition: noActivityData,
        render: () => create('NO_ACTIVITIES_FOUND', EmptyWWPData, buttonProp)
      },
      {
        condition: isCurrentWWP && noWWPAvailable,
        render: () => create('NO_CURRENT_WWP', EmptyWWPData, buttonProp)
      },
      {
        condition: hasLoadingError,
        render: () => create('OTHER_ERROR', EmptyWWPError)
      }
    ];

    const match = cases.find((c) => c.condition);
    return match?.render() || null;
  };

  const renderContent = () => {
    const permittedRoles = ['ACP', 'AC', 'V'];
    if (!permittedRoles.includes(permission?.plan)) {
      return <div>{t('non_permission_access')}</div>;
    }

    if (isLoadingPlan) {
      return null;
    }

    const emptyState = getEmptyState();
    if (emptyState !== null) {
      return emptyState;
    }

    if (!currentCommitment) {
      return null;
    }

    return (
      <>
        <PlanHeader days={days} tableConfig={tableConfig} t={t} />
        <div className={styles.main__wrapper}>
          <div className={styles.activity__row} ref={customPaginator}>
            <CustomPaginator
              data={[{}, ...activities]}
              current={currentPage}
              shouldShowSticky={false}
              perPage={1}
              adjustWidth={115}
              weeklyCommitments
              itemSize={800}
              renderItem={(activity, key) => (
                <>
                  {key > 0 && (
                    <CommitmentsActivity
                      subtradeRole={subtradeRole}
                      permission={permission}
                      key={key}
                      isProgressColumns={isProgressColumns}
                      activity={activity}
                      week={currentWeek}
                      year={currentYear}
                      calendars={calendars}
                      cncListRq={cncListRq}
                      tasksAddedCnc={tasksAddedCnc}
                      handleAddCnc={handleAddCnc}
                      weekcommitment={currentCommitment}
                      t={t}
                    />
                  )}
                </>
              )}
            />
          </div>
          <Manpower
            activities={activities}
            weekcommitment={currentCommitment}
            calendars={calendars}
            t={t}
          />
        </div>
      </>
    );
  };

  const refetchWeeklyPlanData = useCallback(() => {
    if (stateProject.sectorSelected && currentCommitment?.id) {
      return getLookahead({
        scheduleId: stateProject.sectorSelected,
        commitmentId: currentCommitment.id
      });
    }
  }, [stateProject.sectorSelected, currentCommitment?.id]);

  const refetchAllCommitments = useCallback(
    () => weekCommitmentsListRq.refetch(),
    [weekCommitmentsListRq]
  );

  return (
    <>
      <WeeklyPlanCommitmentToolbar
        selectorData={selectorData}
        dateRange={dateRange}
        isError={hasLoadingError}
        isLoading={isLoadingPlan}
        year={currentYear}
        activities={activities}
        currentWeek={currentWeek}
        defaultWWPWeek={defaultWWPWeek}
        weekcommitment={currentCommitment}
        sectorId={stateProject.sectorSelected}
        t={t}
        setIsProgressColumns={setIsProgressColumns}
        setWeekcommitment={setCurrentCommitment}
        refetchAllCommitments={refetchAllCommitments}
        refetchWeeklyPlanData={refetchWeeklyPlanData}
        setShowModalDeletedTasks={setShowModalDeletedTasks}
        handleNavigateSelector={handleNavigateSelector}
      />

      {renderContent()}

      {ModalSystem({
        theme: 'dark',
        title: `${t('weekcommitment.modal_deleted_tasks_title')} (${t('weekcommitment.modal_deleted_tasks_week')} ${currentWeek} - ${moment.utc(dateRange.start).format('DD MMM').replace(/\./g, '')})`,
        width: 780,
        showIconTitle: true,
        iconTitle: <DeletedTaskIcon color="#7DFF8A" />,
        centered: true,
        visible: showModalDeletedTasks,
        setVisible: setShowModalDeletedTasks,
        children: ModalContentTasksCommitmentDeleted(
          deletedTaskCommitments,
          isProgressColumns,
          currentCommitment,
          t
        )
      })}

      <CncForm
        allWeekCommitments={allWeekCommitments}
        allTaskCommitments={allTaskCommitments}
        cncListRq={cncListRq}
        t={t}
        visibleForm={visibleFormCnc.value}
        setVisibleForm={(val) => setVisibleFormCnc({ value: val, tasks: [] })}
        getCncList={getCncList}
        closeForm={true}
        setCncAdded={() => {}}
        responsables={toSelectResponsables}
        weekDefault={currentWeek}
        tasksSelected={visibleFormCnc.tasks}
      />
    </>
  );
};

export default Commitments;
